export const formatNegativeAmount = (amountFull: string, customStyles: any) => {
  const isNegative = amountFull.startsWith("-")
  const displayAmount = isNegative ? amountFull.substring(1) : amountFull
  const amountStyle = isNegative ? { color: customStyles.themePalette.error.lighter } : {}

  return { displayAmount, amountStyle }
}
